import React, { useEffect } from "react";
import Layout from "../../components/Layout";
import Certificates from "../../components/Certificates/Certificates";
import News from "../../components/News/News";
import Partners from "../../components/Partners/Partners";
import Services from "src/components/Services/Services";
import "./Home.css";
import MoreSection from "src/components/MoreSection";
import { useLocation } from "react-router-dom";

const Home: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <Layout>
      <Services />
      <MoreSection />
      <Certificates />
      <News />
      <Partners />
    </Layout>
  );
};

export default Home;
